import { createSlice } from '@reduxjs/toolkit'
import { authServiceApi } from '../apis/auth.service.api'

const initialState = {
  isAuthenticated: false,
  user: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(authServiceApi.endpoints.signIn.matchFulfilled, (state, { payload }) => {
      state.isAuthenticated = true
      state.user = payload.user
      state.token = payload.token
    })
    builder.addMatcher(authServiceApi.endpoints.signOut.matchFulfilled, (state) => {
      state.isAuthenticated = false
      state.user = null
      state.token = null
    })
  },
})

export const { signIn, signOut } = authSlice.actions

export default authSlice.reducer
